var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-steps',{staticClass:"steps",attrs:{"active":_vm.active,"align-center":true,"finish-status":"success"}},_vm._l((_vm.titleList),function(item,index){return _c('el-step',{key:index,attrs:{"title":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }